
import axios from 'axios';
import { API_KEY, BASE_URL, getAxiosConfig } from '../../components/interface/Config';

const API_URL = `${BASE_URL}/resource/patientHealth`;

// Fetch past medication data
export const fetchPastMedications = async (token: string, params: Record<string, any>) => {
    try {
        console.log("Fetching past medications with token:", token);
        const response = await axios.get<{ data: {
            patient_histories: any; patient_healths: any[], pagination: { total: number,per_page:number,current_page:number,last_page:number } 
} }>(API_URL, {
            params,
            headers: getAxiosConfig().headers
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch past medications.');
    }
};

// Delete past medication

